"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("./app"));
var LastVisited = /** @class */ (function () {
    function LastVisited() {
        this.initAppStorage();
        this.addLastVisitedUrl();
    }
    LastVisited.prototype.addLastVisitedUrl = function () {
        var lastVisited = document.referrer;
        if (lastVisited.length === 0 || lastVisited.indexOf(window.location.hostname) === -1) {
            this.setLastVisitedUrl("".concat(window.location.protocol, "//").concat(window.location.hostname));
            return;
        }
        var cleanedUrl = this.getCleanUrl(lastVisited);
        if (cleanedUrl === this.getCleanUrl(window.location.href) || cleanedUrl === LastVisited.getLastVisitedUrl()) {
            return;
        }
        this.setLastVisitedUrl(cleanedUrl);
    };
    LastVisited.prototype.setLastVisitedUrl = function (url) {
        app_1.default.setValue('lastVisited', url);
    };
    LastVisited.getLastVisitedUrl = function () {
        return app_1.default.getValue('lastVisited') || "".concat(window.location.protocol, "//").concat(window.location.hostname);
    };
    LastVisited.prototype.initAppStorage = function () {
        new app_1.default();
    };
    LastVisited.prototype.getCleanUrl = function (url) {
        var urlObj = new URL(url);
        urlObj.search = '';
        urlObj.hash = '';
        return urlObj.toString();
    };
    return LastVisited;
}());
exports.default = LastVisited;
